export default {
  loading: false,
}
